module.exports = __webpack_public_path__ + "img/ic-level-beginner.77af85b8.svg";